import * as React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';

import { Link } from "react-router-dom";
import { Search } from '@mui/icons-material';

export default function AutoCompleteReader(props) {
  const [direction ,setdirection]=React.useState();
  let quraaIds = {
  1: "أبو بكر الشاطري",
  2: "أحمد الحواشي",
  3: "أحمد الطرابلسي",
  4: "أحمد بن على العجمى",
  5: "أحمد صابر",
  6: "أحمد عامر",
  7: "أحمد محمد سلامه",
  8: "أحمد نعينع",
  9: "أكرم العلاقمي",
  10: "إبراهيم الأخضر",
  11: "ابراهيم الجرمي",
  12: "ابراهيم الدوسري",
  13: "ادريس ابكر",
  14: "اسلام صبحي",
  15: "السيد سعيد",
  16: "ابراهيم جمال القرجاوي",
  17: "الدوكالي محمد العالم",
  18: "الزين محمد احمد",
  19: "السديس والشريم",
  20: "العشري عمران",
  21: "العيون الكوشي",
  22: "الفاتح محمد الزبير",
  23: "عبدالبارئ محمد",
  24: "عماد المنصري",
  25: "بندر بليلة",
  26: "توفيق الصايغ",
  27: "جمال شاكر عبدالله",
  28: "جمعان العصيمي",
  29: "حسن صالح",
  30: "حمد سنان",
  31: "خالد الجليل",
  32: "خالد القحطاني",
  33: "خالد المهنا",
  34: "خالد عبدالكافي",
  35: "خليفة الطنيجي",
  36: "زكي داغستاني",
  37: "سعد الغامدي",
  38: "سعود الشريم",
  39: "سهل ياسين",
  40: "سيد رمضان",
  41: "شيرزاد عبدالرحمن طاهر",
  42: "صابر عبدالحكم",
  43: "صلاح بو خاطر",
  44: "طارق عبدالغني دعوب",
  45: "عادل الكلباني",
  46: "عادل ريان",
  47: "عادل مسلم",
  48: "عبد الرحمن العوسي",
  49: "عبد الرزاق الدليمي",
  50: "عبد المنعم عبد المبدئ",
  51: "عبدالبارئ الثبيتي",
  52: "عبدالباسط عبدالصمد",
  53: "عبدالرحمن السديس",
  54: "عبدالرشيد صوفي",
  55: "عبدالعزيز الاحمد",
  56: "عبدالله الكندري",
  57: "عبدالله المطرود",
  58: "عبدالله بصفر",
  59: "عبدالله خياط",
  60: "عبدالله عواد الجهني",
  61: "عبدالله كامل",
  62: "عبدالمحسن الحارثي",
  63: "عبدالمحسن العبيكان",
  64: "عبدالمحسن القاسم",
  65: "عبدالهادي احمد كناكري",
  66: "عبدالودود حنيف",
  67: "عثمان الانداري",
  68: "علي الحذيفي",
  69: "علي جابر",
  70: "علي حجاج السويسي",
  71: "عماد زهير حافظ",
  72: "عمر القزابري",
  73: "فارس عباد",
  74: "وهبي احمد",
  75: "ماهر المعيقلي",
  76: "ماهر شخاشيرو",
  77: "محمد آل عبدالله",
  78: "محمد البراك",
  79: "محمد ايوب",
  80: "محمد الافغاني",
  81: "محمد جبريل",
  82: "محمد حسان",
  83: "محمد رشاد الشريف",
  84: "محمد صالح عالم شاه",
  85: "محمد صديق المنشاوي",
  86: "محمد عارف العسلي",
  87: "محمد نورين صديق",
  88: "محمد عبدالكريم",
  89: "محمد محمود الطبلاوي",
  90: "محمود الرفاعي",
  91: "محمود الشيمي",
  92: "محمود خليل الحصري",
  93: "محمود علي البنا",
  94: "مشاري بن راشد العفاسي",
  95: "مصطفى اسماعيل",
  96: "مصطفى اللاهوني",
  97: "مصطفى رعد العزاوي",
  98: "معيض الحارثي",
  99: "مفتاح السلطني",
  100: "موسى بلال",
  101: "ناصر القطامي",
  102: "نبيل الرفاعي",
  103: "نعمة الحسان",
  104: "هاني الرفاعي",
  105: "وديع اليمني",
  106: "وليد النائحي",
  107: "يونس اسويلص",
  108: "ياسر الدوسري",
  109: "ياسر القرشي",
  110: "ياسر المزروعي",
  111: "يوسف بن نوح احمد"
};
  
  

  const top100Films = [
  { label: "أبو بكر الشاطري" },
  { label: "أحمد الحواشي" },
  { label: "أحمد الطرابلسي" },
  { label: "أحمد بن على العجمى" },
  { label: "أحمد صابر" },
  { label: "أحمد عامر" },
  { label: "أحمد محمد سلامه" },
  { label: "أحمد نعينع" },
  { label: "أكرم العلاقمي" },
  { label: "إبراهيم الأخضر" },
  { label: "ابراهيم الجرمي" },
  { label: "ابراهيم الدوسري" },
  { label: "ادريس ابكر" },
  { label: "اسلام صبحي" },
  { label: "السيد سعيد" },
  { label: "ابراهيم جمال القرجاوي" },
  { label: "الدوكالي محمد العالم" },
  { label: "الزين محمد احمد" },
  { label: "السديس والشريم" },
  { label: "العشري عمران" },
  { label: "العيون الكوشي" },
  { label: "الفاتح محمد الزبير" },
  { label: "عبدالبارئ محمد" },
  { label: "عماد المنصري" },
  { label: "بندر بليلة" },
  { label: "توفيق الصايغ" },
  { label: "جمال شاكر عبدالله" },
  { label: "جمعان العصيمي" },
  { label: "حسن صالح" },
  { label: "حمد سنان" },
  { label: "خالد الجليل" },
  { label: "خالد القحطاني" },
  { label: "خالد المهنا" },
  { label: "خالد عبدالكافي" },
  { label: "خليفة الطنيجي" },
  { label: "زكي داغستاني" },
  { label: "سعد الغامدي" },
  { label: "سعود الشريم" },
  { label: "سهل ياسين" },
  { label: "سيد رمضان" },
  { label: "شيرزاد عبدالرحمن طاهر" },
  { label: "صابر عبدالحكم" },
  { label: "صلاح بو خاطر" },
  { label: "طارق عبدالغني دعوب" },
  { label: "عادل الكلباني" },
  { label: "عادل ريان" },
  { label: "عادل مسلم" },
  { label: "عبد الرحمن العوسي" },
  { label: "عبد الرزاق الدليمي" },
  { label: "عبد المنعم عبد المبدئ" },
  { label: "عبدالبارئ الثبيتي" },
  { label: "عبدالباسط عبدالصمد" },
  { label: "عبدالرحمن السديس" },
  { label: "عبدالرشيد صوفي" },
  { label: "عبدالعزيز الاحمد" },
  { label: "عبدالله الكندري" },
  { label: "عبدالله المطرود" },
  { label: "عبدالله بصفر" },
  { label: "عبدالله خياط" },
  { label: "عبدالله عواد الجهني" },
  { label: "عبدالله كامل" },
  { label: "عبدالمحسن الحارثي" },
  { label: "عبدالمحسن العبيكان" },
  { label: "عبدالمحسن القاسم" },
  { label: "عبدالهادي احمد كناكري" },
  { label: "عبدالودود حنيف" },
  { label: "عثمان الانداري" },
  { label: "علي الحذيفي" },
  { label: "علي جابر" },
  { label: "علي حجاج السويسي" },
  { label: "عماد زهير حافظ" },
  { label: "عمر القزابري" },
  { label: "فارس عباد" },
  { label: "وهبي احمد" },
  { label: "ماهر المعيقلي" },
  { label: "ماهر شخاشيرو" },
  { label: "محمد آل عبدالله" },
  { label: "محمد البراك" },
  { label: "محمد ايوب" },
  { label: "محمد الافغاني" },
  { label: "محمد جبريل" },
  { label: "محمد حسان" },
  { label: "محمد رشاد الشريف" },
  { label: "محمد صالح عالم شاه" },
  { label: "محمد صديق المنشاوي" },
  { label: "محمد عارف العسلي" },
  { label: "محمد نورين صديق" },
  { label: "محمد عبدالكريم" },
  { label: "محمد محمود الطبلاوي" },
  { label: "محمود الرفاعي" },
  { label: "محمود الشيمي" },
  { label: "محمود خليل الحصري" },
  { label: "محمود علي البنا" },
  { label: "مشاري بن راشد العفاسي" },
  { label: "مصطفى اسماعيل" },
  { label: "مصطفى اللاهوني" },
  { label: "مصطفى رعد العزاوي" },
  { label: "معيض الحارثي" },
  { label: "مفتاح السلطني" },
  { label: "موسى بلال" },
  { label: "ناصر القطامي" },
  { label: "نبيل الرفاعي" },
  { label: "نعمة الحسان" },
  { label: "هاني الرفاعي" },
  { label: "وديع اليمني" },
  { label: "وليد النائحي" },
  { label: "يونس اسويلص" },
  { label: "ياسر الدوسري" },
  { label: "ياسر القرشي" },
  { label: "ياسر المزروعي" },
  { label: "يوسف بن نوح احمد" }
];
  
  function selectFun(e){
    window.scrollTo(0,0)
    let target=e.target.value;
    let id = Object.keys(quraaIds).find(key => quraaIds[key] === target);
    if(id){
      if(props.Dir){
        setdirection(`/${id- 1}/${props.Dir}`)
      }
      else
      setdirection(`/${id }`)
  }
  }


  return (

    <Autocomplete
      sx={{ marginTop: '-20px',marginBottom:'30px' , border:"1px solid white" }}
      freeSolo
      options={top100Films.map((option) => option.label)}
      renderInput={(params) => (
        
        <TextField
          {...params}
          placeholder="أسم القارئ"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <HeadsetMicIcon style={{ color: 'white' }} />
            ),
            endAdornment:(
              <Link to={direction}> <Search style={{cursor:"pointer", color:"white" , margin:"5px",borderRadius:"10px"}} /></Link>
            ),
            style: { color: 'white' }
          }}
        />
      )}
      onSelect={selectFun}
      ListboxProps={{
        style: { background: '#27292f', color: 'white' }
      }}
      
    />
  );
}
